import { useEffect, useState } from 'react';
import { messagePlainText, type AskPlatoChat } from '../hooks/use-ask-plato-chat.ts';

const speakingLingerMs = 600;

type SpeakingState = {
    replyLength: number;
    speaking: boolean;
};

const silent: SpeakingState = { replyLength: 0, speaking: false };

/** On while a reply streams and its text grew within the last moment. */
export function useAskPlatoSpeaking(chat: Pick<AskPlatoChat, 'messages' | 'isStreaming'>): boolean {
    const [state, setState] = useState<SpeakingState>(silent);
    const reply = chat.messages.at(-1);
    const replyLength = reply?.role === 'assistant' ? messagePlainText(reply).length : 0;
    const streaming = chat.isStreaming && replyLength > 0;

    if (streaming && replyLength !== state.replyLength) {
        setState({ replyLength, speaking: true });
    } else if (!streaming && state !== silent) {
        setState(silent);
    }

    useEffect(() => {
        if (!state.speaking) {
            return;
        }
        const timer = setTimeout(() => {
            setState((previous) => ({ ...previous, speaking: false }));
        }, speakingLingerMs);
        return () => {
            clearTimeout(timer);
        };
    }, [state]);

    return state.speaking;
}
